import React from 'react'
import {  Card, Accordion, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import '../css/BoxItem.css'; // Tell webpack that Button.js uses these styles
import BoxCard from '../containers/comps/BoxCardContainer'
import '../css/BoxItemDropDown.css'


class BoxItemDropDown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mycheckbox: false
        }

        this.onToggleClick = this.onToggleClick.bind(this)
    }

    onToggleClick(e) {
        console.log(this.state.mycheckbox);
        this.state.mycheckbox = !this.state.mycheckbox;
        console.log(this.state.mycheckbox);
    }


    render() {
        return (
            <Card className="panel panel-default mb-0">


                <Accordion.Toggle as={Card.Header} eventKey={this.props.index + 1} className="p-0">
                    <span>

                        <Row>
                            <div>
                                {this.props.index + 1}.
                            </div>
                            <div>&nbsp;</div>
                            <div>
                                {this.props.name}
                            </div>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    {/* <li><a href="#" onClick={console.log("test")}><FeatherIcon className="iconspacing" icon="plus-square" size="20" /></a></li>
                                    <li><a href="#" onClick={console.log("test")}><FeatherIcon className="iconspacing" icon="edit" size="20" /></a></li>
                                    <li><a href="#" onClick={console.log("test")}><FeatherIcon className="iconspacing" icon="trash-2" size="20" /></a></li> */}
                                    <li><div><FeatherIcon className="iconspacing" icon="chevron-down" size="20" /></div></li>
                                </ul>
                            </div>


                        </Row>
                    </span>
                    <div className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href={"#" + this.props.index + 1}>
                    </div>
                </Accordion.Toggle>

                <Accordion.Collapse id={this.props.index + 1} eventKey={this.props.index + 1} className="panel-collapse collapse in">
                    <Card.Body>

                        {this.props.accordionSubItems.map((el, index) => {
                            return (
                                 this.props.deleteDialog == 'yes' ?

                                 
                                 <BoxCard divText={el} deleteDialog='yes'></BoxCard> :
                                
                                <BoxCard divText={el}></BoxCard>
                            )
                        })}
                    </Card.Body>
                </Accordion.Collapse>

            </Card >
        );
    }
}

export default BoxItemDropDown;